import Layout from '@/layout'

const accountManage = {
    path: '/patient/account',
    component: Layout,
    children: [
        {
            path: 'accountList',
            component: () => import('@/views/patient/account/accountList')
        }
    ]
}

export default accountManage
